<template>
  <div class="uploadImg_wrapper">   
    <div class="img_search" @dragover="dropOverEvent" @drop="dropImg">
      <v-overlay :absolute="absolute" :value="searchLoading">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
        <div class="default_img" v-if="!showUrl">
          <img src="../assets/images/icons/nodata1.svg" alt="">
        </div>
        <div class="img_wrapper" v-if="showUrl">
          <!-- <div class="img" :style="{'background': 'url('+showUrl+') no-repeat center','background-size':'contain'}"></div> -->
          <img :src="showUrl" alt="上传成功图片" />
        </div>
        <div class="btn_text"  v-if="!showUrl">
            <span>将文件拖拽到此处，或</span>
            <!-- <span>点击上传</span> -->
            <div class="hand" @click="upload">
              <input type="hidden" name="imgId" value="466" />
              <span class="link_text">点击上传</span>
            </div>
            <span>上传图片</span>
        </div>
        <!-- <div class="btn_wrapper" @click="upload" v-if="!showUrl">
          <div class="up-inner-box">
            <input type="hidden" name="imgId" value="466" />
            <i class="icon"></i>
            <span>上传图片</span>
          </div>
        </div> -->
        <div class="bottom_wrapper" v-if="showUrl">
            <div class="btn_wrapper grey1" @click="upload">
              <div class="up-inner-box">
                <input type="hidden" name="imgId" value="466" />
                <!-- <v-icon>mdi-cloud-upload-outline</v-icon> -->
                <i class="icon"></i>
                <span>重新上传</span>
              </div>
            </div>
            <v-btn color="primary" @click="search">
              <v-icon>mdi-magnify</v-icon>
              <span>检索</span>
            </v-btn>
        </div>
        <input
          id="ipt_up"
          type="file"
          class="image-upload"
          ref="upload"
          @change="uploadImg"
        />
        <div class="tips" v-if="!showUrl">图片格式支持jpg，jpeg，png；大小在5MB以内 （目前只支持外观专利）</div>
    </div>
    
    <!-- <v-card
      class="d-flex pa-2 justify-center mb-6"
      outlined
      tile
      @click="upload"
    >
      <div class="up-img-hide" id="upload_view" v-if="showImage">
        <img :src="showUrl" alt="上传成功图片" style="max-width: 196px" />
        <input type="hidden" name="imgId" value="466" />
      </div>
      <div class="up-inner-box" v-if="!showImage">
        <v-btn
          class="ma-2"
          color="indigo"
          dark
          depressed
          style="margin: 10px auto"
        >
          <v-icon dark> mdi-cloud-upload </v-icon>
        </v-btn>

        <div class="upimg-title">点击上传图片。</div>
      </div>

      <input
        id="ipt_up"
        type="file"
        class="image-upload"
        ref="upload"
        @change="uploadImg"
      />
    </v-card> -->
    <!-- <div class="d-flex justify-end">
      <v-btn color="primary" @click="search" :loading="searchLoading">检索</v-btn>
    </div> -->
  </div>
</template>
 
 <script>
import { mapState, mapMutations, mapActions } from "vuex";
import ApiUrl from "../store/apiurl";
import Qs from "qs";
export default {
  components: {},
  data() {
    return {
      absolute: true,
      searchLoading:false,
      showImage: false,
      files: [],
      showUrl: "",
      imageId: 0,
    };
  },
  computed: {
     ...mapState('search', {
      searchType: state =>state.searchType,
      searchKey: state => state.searchKey
    })
  },
  mounted() {
    if(this.searchType == 2) {
      this.showUrl = this.searchKey.showUrl
      this.showImage = this.searchKey.showImage
      this.imageId = this.searchKey.imageId
    }
  },
  methods: {
    ...mapActions("search", ["getSearchImg", "imgUpload"]),
    ...mapMutations('search',['setSearchType','setSearchKey']),
    dropOverEvent(e) {
      e.preventDefault()
    },
    dropImg(e) {
      e.preventDefault()
      let fileList = e.dataTransfer.files;
      let file = fileList[0]
      this.uploadImg1(file)
    },
    upload() {
      let uploadbtn = this.$refs.upload;
      uploadbtn.click();
    },
    uploadImg() {
      var file = document.getElementById("ipt_up").files[0];
      let formData = new FormData();
      formData.append("file", file);
      let data = formData;
      let _this = this;
      if(file.type.indexOf('jpeg')<0 && file.type.indexOf('png')<0 && file.type.indexOf('jpg')<0) {
        this.$message({
          type: 'info',
          message: '请确认图片格式后再上传'
        })
        return false
      }
      if(file.size > 1024*1024*5) {
        this.$message({
          type: 'info',
          message: '图片大小不能超过5M'
        })
        return false
      }
      this.imgUpload({
        data: data,
        handle(res) {
          _this.$nextTick(()=>{
            _this.showUrl = ApiUrl.res_url + res.imageUri;
            _this.showImage = true;
            _this.imageId = res.imageId;
          })
        },
      });
    },
    uploadImg1(val) {
      var file = val;
      let formData = new FormData();
      formData.append("file", file);
      let data = formData;
      let _this = this;
      if(file.type.indexOf('jpeg')<0 && file.type.indexOf('png')<0 && file.type.indexOf('jpg')<0) {
        this.$message({
          type: 'info',
          message: '请确认图片格式后再上传'
        })
        return false
      }
      if(file.size > 1024*1024*5) {
        this.$message({
          type: 'info',
          message: '图片大小不能超过5M'
        })
        return false
      }
      this.imgUpload({
        data: data,
        handle(res) {
          _this.$nextTick(()=>{
            _this.showUrl = ApiUrl.res_url + res.imageUri;
            _this.showImage = true;
            _this.imageId = res.imageId;
          })
        },
      });
    },
    search() {
      {
          this.searchLoading = true;
        var _this = this;
        var postData = Qs.stringify({ imgId: this.imageId });
        this.getSearchImg({
          data: postData,
          handle(res) {
            _this.searchLoading = false;
            if (res.q) {
              _this.setSearchType(2)
              _this.setSearchKey({showImage: _this.showImage,showUrl: _this.showUrl,imageId: _this.imageId})
              _this.$router.push({
                path: "/search/result",
                query: { 
                  'str': res.q,
                  'model':'simage'
                },
              });
            }else {
              _this.$message({
                type: 'info',
                message: res.message
              })
            }
          },
        });
      }
    },
  },
};
</script>
 
 <style scoped>
.image-upload {
  height: 0;
  width: 0;
  visibility: hidden;
  position: absolute;
}

.up-inner-box {
  width: 100%;
  text-align: center;
  margin-right: auto;
  margin-left: auto;
  border-radius: 6px;
  overflow: hidden;
}
.upimg-title {
}
</style>